import { BuzerIcon } from "../../../BuzerIcons";

// Prázdny stav — JEDEN vzor pre celú appku: ikona v krúžku (farba témy) + nadpis + popis,
// voliteľne akcie (children, napr. dvojica Button block) pod textom.
// Vzor sa predtým kopíroval inline (Aktivita, Archív, Dnes) — teraz žije tu, aby sa
// prázdne obrazovky nerozchádzali (§6a pravidlo 5/7).
// `icon` = názov BuzerIcon (string) alebo hotový uzol.
export function EmptyState({ icon, title, desc, children, className = "", ...rest }) {
  return (
    <div className={["bz-empty", className].filter(Boolean).join(" ")} {...rest}>
      {icon && (
        <span className="bz-empty__icon">
          {typeof icon === "string" ? <BuzerIcon name={icon} size={22} color="currentColor" /> : icon}
        </span>
      )}
      <div className="bz-empty__title">{title}</div>
      {desc && <div className="bz-empty__desc">{desc}</div>}
      {children && <div className="bz-empty__actions">{children}</div>}
    </div>
  );
}
